export default {
  baseUrl: "https://api.kinguest.com.cn/api/", // 接口公共域名
};
